import { PropsWithChildren, useCallback } from 'react';
import { __useInternalDragAndDrop } from './Context/DragAndDropContext';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DroppableProps extends IntrinsicProps {
  id?: string | undefined;
}

export function Droppable({ children, ...props }: PropsWithChildren<DroppableProps>) {
  const { retrieveListener } = __useInternalDragAndDrop();

  const onDropCallback = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();

      const droppedItem = event.dataTransfer.getData('text');
      const onDrop = retrieveListener(droppedItem);

      if (!onDrop) {
        throw Error('There is no listener registered under: ' + droppedItem);
      }

      onDrop(props.id);
    },
    [props.id, retrieveListener],
  );

  const onDragoverCallback = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  return (
    <div onDrop={onDropCallback} onDragOver={onDragoverCallback} {...props}>
      {children}
    </div>
  );
}
